var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.load),expression:"load"}],ref:_vm.name,staticClass:"px-2 ma-n4",staticStyle:{"height":"300px"},attrs:{"id":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }